import { render, staticRenderFns } from "./customSteps.vue?vue&type=template&id=31601cfc&scoped=true"
import script from "./customSteps.vue?vue&type=script&lang=js"
export * from "./customSteps.vue?vue&type=script&lang=js"
import style0 from "./customSteps.vue?vue&type=style&index=0&id=31601cfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31601cfc",
  null
  
)

export default component.exports